/**
 * Asynchronously loads the component for AskMiaMeasurePage
 */

import { lazyLoad } from 'utils/loadable';

export const AskMiaMeasurePage = lazyLoad(
  () => import('./AskMiaMeasurePage'),
  module => module.default,
);

